













































































































































































































































import Advert from "@/store/entities/advert";
import City from "@/store/entities/city";
import Job from "@/store/entities/job";
import axios from "axios";
import { Component, Vue } from "vue-property-decorator";
import Ajax from '../../..//lib/ajax';
import moment from "moment";
@Component({})
export default class AddAds extends Vue {
  isValid: boolean = false;
  startDateMenu: boolean = false;
  dialog: boolean = true;
  startDate: string = null;
  isEdit: boolean = false;
  cities:City[]=[];
  city:City=new City();
  jobs: Job[] = [];
  job:Job=new Job();
  advert: Advert=new Advert();
  categoryItems:any[]=[];
  category:any={};
  connectionType=1;
  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },

  

    };
  }
  get getStartDate() {
    return this.startDate ? moment(this.startDate).format("DD-MM-yyyy") : "";
  }

  async created() {
    this.categoryItems= [
        { id: 1, name: "Proje" },
        { id: 2, name: "Şantiye Şefi" }
      
      ]
    await this.getCities();
    await this.getJobs();
  }

  async getCities(){
    var response = await Ajax.get(
        '/api/services/app/Admin/GetCities'
      );
      var data = response.data.result.items;
      this.cities=data;
  }

  async saveAds(){
    this.advert.category=this.category.id;
    this.advert.cityId=this.city.id;
    this.advert.connectionType=this.connectionType;
    this.advert.jobId=this.job.id;

    this.saveAd();
  


  }
  async saveAd() {
    var formData = new FormData();
    formData.append('CityId', this.advert.cityId.toString());
  formData.append('Name', this.advert.name);
  formData.append('ImageFile', this.advert.imageFile);
  formData.append('PhoneNumber', this.advert.phoneNumber);
  formData.append('JobId', this.advert.jobId.toString());
  formData.append('ConnectionType', this.advert.connectionType.toString());
  formData.append('Email', this.advert.email);
  formData.append('Description', this.advert.description);
  formData.append('Category', this.advert.category.toString());
  formData.append('CreationTime', this.startDate.toString());
    const response = await Ajax.post('/api/services/app/Admin/SaveAdvert', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
  }
  async getJobs(){
    var response = await Ajax.get(
        '/api/services/app/Admin/GetJobs'
      );
      var data = response.data.result.items;
      this.jobs=data;
  }
  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
  }

openFileInput() {
  const fileInput = this.$refs.fileInput as HTMLInputElement | undefined;
  
  if (fileInput) {
    fileInput.click();
  }
}

handleFileChange(event) {
  const selectedFile = event.target.files[0];
  if (selectedFile) {
 
    this.advert.imageFile=selectedFile;
    // Resim seçildiğinde bu kod çalışır
    const imagePreview = this.$refs.imagePreview as HTMLImageElement | undefined;
    if (imagePreview) {
      // Seçilen resmi önizleme alanında göster
      const reader = new FileReader();
      reader.onload = (e) => {
        if (typeof e.target.result === 'string') {
          imagePreview.src = e.target.result;
        }
      };
      reader.readAsDataURL(selectedFile);
    }
  }
}
  
  }
